<input [class]="inputCssClass" type="number" (focusin)="onFocusIn($event)" (focusout)="onFocusOut($event)" (blur)="blur.emit($event)" [formControl]="numberForm" matInput [placeholder]="placeholder" step="any" />
